export interface DetectionResult {
  shouldPrompt: boolean;
  guestId: string | null;
  authId: string | null;
  guestCounts: any;
  stats: any;
  plan: any;
}

export async function detectPendingMigration(_userId?: string): Promise<DetectionResult> {
  return { shouldPrompt: false, guestId: null, authId: null, guestCounts: null, stats: null, plan: null };
}

export const executeMigration = async () => ({});
export const computeMigrationPlan = () => ({});
export const loadSnapshot = async () => ({});
export const countSnapshot = async () => ({});
export const markMigrationDone = async () => ({});
export const purgeGuestData = async () => ({});